import { RepairSessionView } from './RepairSessionView';

export default function Repairs() {
  return (
    <div className="page page-tests page-repairs">
      <RepairSessionView />
    </div>
  );
}

